import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f6c4255"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CourierSchedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CourierSchedule__title" }, "График работы курьера", -1))
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center flex-col px-6 py-4"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, " Загрузка данных о графике работы курьера... ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении данных о графике работы курьера произошла ошибка ", -1))
const _hoisted_6 = {
  key: 2,
  class: "text-gray-400 text-sm"
}
const _hoisted_7 = {
  key: 1,
  class: "px-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isProcessing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createVNode(_component_the_button, {
                    class: "primary small text mt-3",
                    onClick: _ctx.loadCourierSchedule
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.schedule.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Нет данных"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.schedule, (schedule) => {
            return (_openBlock(), _createElementBlock("div", {
              key: schedule.id,
              class: "CourierSchedule__row"
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.WORK_WEEK_DAYS[schedule.weekday]), 1),
              _createElementVNode("div", null, _toDisplayString(schedule.workTimeFrom), 1),
              _createElementVNode("div", null, _toDisplayString(schedule.workTimeUntil), 1)
            ]))
          }), 128))
        ]))
  ]))
}